import { useQuery } from '@tanstack/react-query';
import { Building2, Users, UserPlus, HeartPulse } from 'lucide-react';
import { chainApi } from '@/api/chain';
import { PageHeader } from '@/components/layout/PageHeader';
import { StatKpiCard } from '@/components/layout/StatKpiCard';

export default function ChainDashboardPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['chain-dashboard'],
    queryFn: async () => {
      const r = await chainApi.getDashboard();
      return r.data.data as {
        usage: { hospitalCount: number; userCount: number };
        leadCount: number;
        patientCount: number;
      };
    },
  });

  if (isLoading) {
    return (
      <div className="thms-page-shell">
        <p className="text-sm text-artis-slate">Loading chain dashboard…</p>
      </div>
    );
  }

  const usage = data?.usage;

  const tiles = [
    {
      title: 'Hospitals',
      value: usage?.hospitalCount ?? 0,
      icon: Building2,
      gradient: 'from-artis-gold to-amber-600',
      description: 'Sites in your chain',
    },
    {
      title: 'Admin users',
      value: usage?.userCount ?? 0,
      icon: Users,
      gradient: 'from-blue-500 to-indigo-600',
      description: 'Hospital administrators',
    },
    {
      title: 'Leads (all sites)',
      value: data?.leadCount ?? 0,
      icon: UserPlus,
      gradient: 'from-violet-500 to-purple-600',
      description: 'CRM leads across chain',
    },
    {
      title: 'Patients (all sites)',
      value: data?.patientCount ?? 0,
      icon: HeartPulse,
      gradient: 'from-emerald-500 to-teal-600',
      description: 'Registered patients',
    },
  ];

  return (
    <div className="thms-page-shell">
      <PageHeader title="Chain dashboard" subtitle="Consolidated usage across your hospital network" />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {tiles.map((tile) => (
          <StatKpiCard key={tile.title} {...tile} />
        ))}
      </div>
    </div>
  );
}
